import Relation from "../singleton/relation";

export default {

    getAll: Relation.getAll.bind(Relation),

    getSiblings: Relation.getSiblings.bind(Relation),

    create: Relation.create.bind(Relation),

    rename: Relation.rename.bind(Relation)

}